import { render, staticRenderFns } from "./lotto-list-detail.vue?vue&type=template&id=75717f19&scoped=true&"
import script from "./lotto-list-detail.vue?vue&type=script&lang=js&"
export * from "./lotto-list-detail.vue?vue&type=script&lang=js&"
import style0 from "./lotto-list-detail.vue?vue&type=style&index=0&id=75717f19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75717f19",
  null
  
)

export default component.exports